import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=2a485589&"
import script from "./LoadingModal.vue?vue&type=script&lang=ts&"
export * from "./LoadingModal.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports